import { Link } from "react-router-dom";
import LeftIcon from "../../../Assets/Icons/LeftIcon";

import "./style.css";

const Banner = () => {
  return (
    <div className="banner-container">
      <div className="banner-image " >
        <div className='maxWidth-content'>
        <Link to="">
          <LeftIcon />
        </Link>
        <h1>Coaches</h1>
        </div>
      </div>
    </div>
  );
};

export default Banner;
